<template>
	<nut-navbar
		class="navbar"
		title="参数与设置"
		fixed
		:placeholder="false"
		leftShow
		@on-click-back="goBack('/home')"
	>
	</nut-navbar>
	<div class="container">
		<div class="group">
			<CellItem title="头像">
				<template #content>
					<nut-avatar
						@click="$router.push('/icon')"
						size="large"
						:icon="setting.icon"
					></nut-avatar>
				</template>
			</CellItem>
			<CellItem
				title="设备名称"
				:desc="setting.name"
				is-link
				@click="modalVisible = true"
			>
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_DEVICENAME)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem
				title="屏幕角度"
				:desc="selectedAngleText"
				is-link
				@click="modePickerShow = true"
			>
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_SCREEN_ANGLE)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem title="屏幕亮度">
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_SCREEN_LIGHT)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
				<template #content>
					<nut-range
						v-model="brightness"
						hidden-tag
						hidden-range
						@drag-end="handleBrightnessDragover"
					>
						<template #button>
							<div class="custom-button">{{ brightness }}</div>
						</template>
					</nut-range>
				</template>
			</CellItem>
			<CellItem
				title="分屏模式"
				:desc="setting.windows_mode ? '开启' : '关闭'"
				is-link
				@click="$router.push('/windows')"
			>
				<template #rightIcon>
					<nut-icon
						@click.stop="
							handleOpenDialog(PARAM_SETTING_SCREEN_MODE)
						"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem
				title="App自运行"
				:desc="selectedAppSelfText"
				is-link
				@click="appSelfPickerShow = true"
			>
				<template #rightIcon>
					<nut-icon
						@click.stop="handleOpenDialog(PARAM_SETTING_APP_SELF)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem
				title="设备管理员"
				:desc="setting.admin_count"
				is-link
				v-if="typeof setting.admin_count !== 'undefined'"
				@click="$router.push('/admins')"
			>
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_DEVICE_ADMIN)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem
				title="远程截屏"
				is-link
				v-if="typeof setting.screen !== 'undefined'"
				@click="$router.push('/screen')"
			></CellItem>
		</div>
		
		<div class="group">
			<CellItem title="设备编号" :desc="setting.device_num">
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_DEVICE_ID)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem title="设备型号" :desc="setting.hwvers"></CellItem>
			<CellItem title="OS版本号" :desc="setting.osvers"></CellItem>
			<CellItem
				title="APP版本号"
				:desc="setting.appvers"
				is-link
				@click="$router.push('/appUpdate')"
			>
				<template #rightIcon>
					<nut-icon
						@click.stop="
							handleOpenDialog(PARAM_SETTING_APP_VERSION)
						"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
			<CellItem
				title="显示分辨率"
				:desc="`${setting.x} x ${setting.y}`"
			></CellItem>
			<CellItem
				@click="$router.push('/aboutus')"
				title="软件供应商"
				desc="七月流火"
				is-link
			></CellItem>
			<CellItem title="激活日期" :desc="setting.activate_date"></CellItem>
			<CellItem
				title="软件授权/续费"
				:desc="setting.service_level"
				is-link
				v-if="typeof setting.service_level !== 'undefined'"
				@click="$router.push('/devfee')"
			></CellItem>
		</div>
		<div class="group">
			<CellItem
				title="设备运行检测"
				is-link
				v-if="typeof setting.examine_device !== 'undefined'"
				@click="$router.push('/deviceExamine')"
			>
				<template #rightIcon>
					<nut-icon
						@click="handleOpenDialog(PARAM_SETTING_DEVICE_EXAMINE)"
						:size="14"
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
					></nut-icon>
				</template>
			</CellItem>
		</div>
	</div>
	<!-- todo 此处待调整 不能用v-model -->
	<nut-picker
		v-if="modePickerShow"
		v-model="selectedAngleVal"
		v-model:visible="modePickerShow"
		:columns="angleColumns"
		title="屏幕角度"
		@confirm="handleConfirm"
	>
	</nut-picker>
	<nut-picker
		v-if="appSelfPickerShow"
		v-model="selectedAppSelfVal"
		v-model:visible="appSelfPickerShow"
		:columns="appSelfRuncolumns"
		title="APP自运行"
		@confirm="handleConfirmApp"
	></nut-picker>
	<change-device-name
		v-if="modalVisible"
		v-model="modalVisible"
		:name="setting.name"
		@success="handleSuccess"
	></change-device-name>
</template>

<script>
import { onMounted, ref, computed } from 'vue';
import { CellItem } from '../../components';
import ChangeDeviceName from './components/changeDevicename.vue';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import {
	PARAM_SETTING_DEVICENAME,
	PARAM_SETTING_SCREEN_ANGLE,
	PARAM_SETTING_SCREEN_LIGHT,
	PARAM_SETTING_SCREEN_MODE,
	PARAM_SETTING_SCREEN_TOUCH,
	PARAM_SETTING_APP_SELF,
	PARAM_SETTING_DEVICE_ADMIN,
	PARAM_SETTING_DEVICE_ID,
	PARAM_SETTING_DEVICE_EXAMINE,
	PARAM_SETTING_APP_VERSION,
} from '@/constants/tiptype';
import { settingApi } from '@/apis';
import { angleColumns, appSelfRuncolumns } from '@/constants/pickerColumns';
import { Toast } from '@nutui/nutui';
//import { Toast } from '@nutui/nutui';

export default {
	name: 'Setting',
	components: {
		CellItem,
		ChangeDeviceName,
	},
	setup() {
		const { goBack } = useNavigate();
		const brightness = ref(0);
		const modePickerShow = ref(false);
		const selectedAngleVal = ref(['portrait']);
		const selectedAngleText = computed(() => {
			return selectedAngleVal.value[0]
				? angleColumns.filter(
						(angle) => angle.value === selectedAngleVal.value[0]
				  )[0].text
				: '';
		});
		const appSelfPickerShow = ref(false);
		const selectedAppSelfVal = ref([]);
		const selectedAppSelfText = computed(() => {
			return selectedAppSelfVal.value[0]
				? appSelfRuncolumns.filter(
						(item) => item.value === selectedAppSelfVal.value[0]
				  )[0].text
				: '';
		});
		const setting = ref({});
		const modalVisible = ref(false);
		const { handleOpenDialog } = useDialog();

		const editSetting = async (params) => {
			try {
				await settingApi.setting_edit(params);
				Toast.success('修改成功', {
					async onClose() {
						await settingApi.setting_load_data();
					},
				});
			} catch (error) {
				Toast.fail('修改失败');
			}
		};

		const handleConfirm = () => {
			editSetting({
				type: 'angle',
				value: selectedAngleVal.value[0] === 'portrait' ? 90 : 0,
			});
		};
		const handleConfirmApp = () => {
			editSetting({
				type: 'auto_startup',
				value: selectedAppSelfVal.value[0] === 'on' ? 1 : 0,
			});
		};

		const handleBrightnessDragover = async () => {
			editSetting({
				type: 'setbrightness',
				value: brightness.value,
			});
		};

		const handleSuccess = (val) => {
			setting.value.name = val;
		};

		const getSettings = async () => {
			const res = await settingApi.setting_load_data();
			setting.value = res || {};
			selectedAngleVal.value = [
				res.angle == 0 ? 'landscape' : 'portrait',
			];
			brightness.value = +res.brightness;
			selectedAppSelfVal.value = [res.AutoStartup == 0 ? 'off' : 'on'];
		};

		onMounted(() => {
			getSettings();
		});
		return {
			PARAM_SETTING_DEVICENAME,
			PARAM_SETTING_SCREEN_ANGLE,
			PARAM_SETTING_SCREEN_LIGHT,
			PARAM_SETTING_SCREEN_MODE,
			PARAM_SETTING_SCREEN_TOUCH,
			PARAM_SETTING_APP_SELF,
			PARAM_SETTING_DEVICE_ADMIN,
			PARAM_SETTING_DEVICE_ID,
			PARAM_SETTING_DEVICE_EXAMINE,
			PARAM_SETTING_APP_VERSION,
			setting,
			brightness,
			angleColumns,
			appSelfRuncolumns,
			modePickerShow,
			appSelfPickerShow,
			selectedAngleText,
			selectedAngleVal,
			selectedAppSelfVal,
			selectedAppSelfText,
			modalVisible,

			handleConfirm,
			handleConfirmApp,
			goBack,
			handleOpenDialog,
			handleBrightnessDragover,
			handleSuccess,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	margin-top: $navbar-height;
	overflow: hidden;
	background: $bg_color;

	.group {
		margin-bottom: 24px;
		background: #fff;
		:deep(.cell-icon) {
			@include flex-center;
		}
	}

	.custom-button {
		width: 26px;
		font-size: 10px;
		line-height: 18px;
		text-align: center;
		background-color: $primary-color;
		border-radius: 100px;
		color: #fff;
	}
}
</style>
